import React from 'react';

import * as S from './styled';

const ContainerMenu = ({ isOpen, children, onClick }) => {
  

  return (
    <>
      <S.ContainerMenu onClick = {onClick} className={isOpen ? 'active' : ''}>
        {children} 
      </S.ContainerMenu>
    </>
  );
};


export default ContainerMenu;